import * as React from 'react'

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string
    titleId?: string
}

const Grid7 = React.forwardRef<SVGSVGElement, Props>(
    ({ title, titleId, ...props }, ref) => {
        const ariaProps = title
            ? { role: 'img', 'aria-labelledby': titleId || 'grid7-title' }
            : { 'aria-hidden': true }

        return (
            <svg
                ref={ref}
                width="1em"
                height="1em"
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                {...ariaProps}
                {...props}
            >
                {title ? (
                    <title id={titleId || 'grid7-title'}>{title}</title>
                ) : null}
                <rect width="8.64165" height="8.64165" fill="currentColor" />
                <rect
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="11.522"
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="11.522"
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="23.0439"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="23.0439"
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="23.0439"
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
            </svg>
        )
    }
)

Grid7.displayName = 'Grid7'
export default React.memo(Grid7)
